import { Separator } from '../../components/ui/separator';

/** Footer hairline — the shared `Separator` (card-border token) at the footer's width. */
export function FooterDivider({ className }: { className?: string }) {
  return <Separator className={className} />;
}
